import React, { useEffect, useState } from 'react';
import PageTitle from 'ui/views/layouts/BaseLayout/PageTitle';
import { MobileMargin } from 'ui/views/layouts/BaseLayout';
import SectionHeading from 'ui/elements/SectionHeading';
import Resources from 'util/resource/Resources';
import { getOrElse, isValidating } from 'util/resource';
import { scrollToTop } from 'util/scroll';
import { useShortlistedCompanies } from 'apis/CompanyAPI/users/useShortlistedCompanies';
import FeaturedCompanyMatchesForCurrentUser from 'pages/Discover/FeaturedCompanyMatchesForCurrentUser';
import CollectionTabs from './CollectionTabs';
import CollectionCompaniesTable from './CollectionCompaniesTable';
import CompaniesFilters, { CompaniesFilterValues } from './CompaniesFilters';
import useCollectionShortlists from './useCollectionShortlists';

/** All the companies in the user's lists, behind the `collections-hub` feature preview. */
export default function CollectionsHub() {
  const { resource: shortlistResource, setShortlists } = useCollectionShortlists();
  const [filters, setFilters] = useState<CompaniesFilterValues>({ orderBy: 'latest-activity', raising: false });
  const { resource: companiesResource } = useShortlistedCompanies(filters);

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <>
      <PageTitle title="Collections" />
      <Resources resources={[shortlistResource]}>
        {([shortlists]) => (
          <MobileMargin>
            <CollectionTabs shortlists={shortlists.values} setShortlists={setShortlists} />
            <SectionHeading heading="All companies">
              <CompaniesFilters values={filters} onChange={setFilters} />
            </SectionHeading>
            <CollectionCompaniesTable
              companies={getOrElse(companiesResource, { values: [] }).values}
              shortlists={shortlists.values}
              setShortlists={setShortlists}
              isLoading={isValidating(companiesResource)}
              emptyMessage={
                filters.raising
                  ? 'None of the companies in your lists are raising right now.'
                  : 'Save companies to your lists to keep track of them here.'
              }
            />
          </MobileMargin>
        )}
      </Resources>
      <FeaturedCompanyMatchesForCurrentUser useCarouselOnLargeScreen className="u-section-spacing-top" />
    </>
  );
}
